import styled from "@emotion/styled";

import { alpha } from "metabase/lib/colors";

export const DimensionListItem = styled.li`
  border-color: ${alpha("accent2", 0.2)};
`;
